export const WHATSAPP_PEOPLE_VARIABLES = [
  { value: "contact.firstname", label: "First Name" },
  { value: "contact.lastname", label: "Last Name" },
  { value: "contact.fullname", label: "Full Name" },
  { value: "contact.company", label: "Current Company" },
  { value: "contact.jobtitle", label: "Current Role" },
  { value: "contact.phone", label: "Personal Phone Number" },
  { value: "contact.personalemail", label: "Personal Email" },
  { value: "contact.workemail", label: "Work Email" },
  { value: "contact.linkedin", label: "LinkedIn" },
  { value: "contact.timezone", label: "Timezone" },
  { value: "contact.company_hq", label: "Company HQ Location" },
  { value: "contact.status", label: "Contact Status" },
];

export const WHATSAPP_SENDER_VARIABLES = [
  { value: "sender.name", label: "Sender Name" },
  { value: "sender.firstname", label: "Sender First Name" },
  { value: "sender.lastname", label: "Sender Last Name" },
  { value: "sender.email", label: "Sender Email" },
  { value: "sender.company", label: "Sender Company" },
  { value: "sender.meeting_link", label: "Sender Meeting URL" },
];

export const WHATSAPP_COMPANY_VARIABLES = [
  { value: "company.name", label: "Company Name" },
  { value: "company.industry", label: "Industry" },
  { value: "company.website", label: "Website" },
  { value: "company.size", label: "Company Size" },
  { value: "company.revenue", label: "Annual Revenue" },
  { value: "company.linkedin", label: "LinkedIn" },
  { value: "company.city", label: "City" },
  { value: "company.state", label: "State" },
  { value: "company.country", label: "Country" },
  { value: "company.postal_code", label: "Postal Code" },
];

export const WHATSAPP_VARIABLE_TYPES = [
  ...WHATSAPP_PEOPLE_VARIABLES,
  ...WHATSAPP_SENDER_VARIABLES,
  ...WHATSAPP_COMPANY_VARIABLES,
];

export const BUTTON_TYPES = {
  URL: "URL",
  PHONE_NUMBER: "PHONE_NUMBER",
  COPY_CODE: "COPY_CODE",
  QUICK_REPLY: "QUICK_REPLY",
  VISIT_WEBSITE: "VISIT_WEBSITE",
  CALL: "CALL",
};

export const HEADER_TYPES = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  DOCUMENT: "DOCUMENT",
};

export const MEDIA_TYPES = HEADER_TYPES;

export const TEMPLATE_FORMATS = {
  CUSTOM: "CUSTOM",
  CAROUSEL: "CAROUSEL",
};

export const MEDIA_ACCEPT_TYPES = {
  [HEADER_TYPES.IMAGE]: "image/*",
  [HEADER_TYPES.VIDEO]: "video/*",
  [HEADER_TYPES.DOCUMENT]: ".pdf,.doc,.docx",
};

export const ACCEPTED_MIME_TYPES = {
  [HEADER_TYPES.IMAGE]: ["image/jpeg", "image/png", "image/gif", "image/webp"],
  [HEADER_TYPES.VIDEO]: ["video/mp4", "video/quicktime", "video/x-msvideo", "video/webm"],
  [HEADER_TYPES.DOCUMENT]: ["application/pdf"],
};

export const FILE_SIZE_LIMITS_MB = {
  [HEADER_TYPES.IMAGE]: 5,
  [HEADER_TYPES.VIDEO]: 16,
  [HEADER_TYPES.DOCUMENT]: 15,
};

export const FILE_TYPE_LABELS = {
  [HEADER_TYPES.IMAGE]: {
    label: "image",
    extensions: "image files (JPEG, PNG, GIF, WEBP)",
  },
  [HEADER_TYPES.VIDEO]: {
    label: "video",
    extensions: "video files (MP4, MOV, AVI, WEBM)",
  },
  [HEADER_TYPES.DOCUMENT]: {
    label: "PDF",
    extensions: "PDF files",
  },
};

export const MAX_FILE_SIZE_MB = 10;

export const UPLOAD_LIMITS = {
  FILE_SIZE_MB: MAX_FILE_SIZE_MB,
};

export const validateMediaFile = (file, mediaType) => {
  const acceptedTypes = ACCEPTED_MIME_TYPES[mediaType];
  const maxSizeMB = FILE_SIZE_LIMITS_MB[mediaType];
  const typeInfo = FILE_TYPE_LABELS[mediaType];

  if (!acceptedTypes || !maxSizeMB || !typeInfo) {
    return { valid: false, error: "Invalid media type" };
  }

  const isValidType = acceptedTypes.includes(file.type);
  if (!isValidType) {
    return {
      valid: false,
      error: `Please upload ${typeInfo.extensions} only`,
    };
  }

  const fileSizeMB = file.size / (1024 * 1024);
  if (fileSizeMB > maxSizeMB) {
    const capitalizedLabel = typeInfo.label.charAt(0).toUpperCase() + typeInfo.label.slice(1);
    return {
      valid: false,
      error: `${capitalizedLabel} size must be less than ${maxSizeMB} MB`,
    };
  }

  return { valid: true, error: null };
};

export const VARIABLE_REGEX = /\{\{(\d+)\}\}/g;
export const VARIABLE_MATCH_REGEX = /\{\{(\d+)\}\}/;

export const VARIABLE_SECTIONS = {
  BODY: "body",
  HEADER: "header",
  MESSAGE: "message",
};

export const DEFAULT_WHATSAPP_CAMPAIGN_DATA = {
  name: "",
  recipientLists: [],
  excludedLists: [],
  excludeSome: false,
  messageTemplate: null,
  messageContent: "",
  ctaButtons: [],
  headerType: HEADER_TYPES.TEXT,
  headerText: "",
  headerMedia: null,
  templateFormat: TEMPLATE_FORMATS.CUSTOM,
  carouselCards: [],
  cardMediaFormat: HEADER_TYPES.IMAGE,
  carouselSamplePreview: null,
};

export const EDITABLE_BUTTON_TYPES = [
  BUTTON_TYPES.URL,
  BUTTON_TYPES.PHONE_NUMBER,
  BUTTON_TYPES.COPY_CODE,
];

export const isEditableButton = (button) =>
  EDITABLE_BUTTON_TYPES.includes(button?.type);

export const isTemplateButton = (button) =>
  button?.type === BUTTON_TYPES.QUICK_REPLY || button?.isFromTemplate === true;

export const getHeaderAcceptType = (headerType) =>
  MEDIA_ACCEPT_TYPES[headerType] || "";

export const getButtonTypeLabel = (type) => {
  const labels = {
    [BUTTON_TYPES.URL]: "Visit Website",
    [BUTTON_TYPES.PHONE_NUMBER]: "Contact Us",
    [BUTTON_TYPES.COPY_CODE]: "Copy Code",
    [BUTTON_TYPES.QUICK_REPLY]: "Quick Reply",
  };
  return labels[type] || type;
};

export const CAMPAIGN_NAME_MAX_LENGTH = 50;

export const DEFAULT_RETRY_CONFIG = {
  retryEnabled: false,
  retryAfter: 6,
  maxRetries: 10,
  retryUntil: null,
  retryEligibilityPercentage: 1,
};

export const RETRY_DESCRIPTION_TEXT = "If a message fails to send, it will be retried automatically at the interval you choose, until the specified deadline. This helps maximize delivery without requiring any manual effort.";

export const CRITICAL_VALIDATION_FIELDS = ["recipients", "whatsappConfig", "messageTemplate"];

export const RETRY_VALIDATION_FIELDS = ["retryAfter", "maxRetries", "retryEligibilityPercentage"];

